export const isMobileNavOpen = state => state.header.stateOpenMenuMobileSlide;

export const getMenuVersion = state => state.header.versionOpenMenuMobileSlide;

export const isSpecificMobileNavOpen = (state, menuVersion) =>
    isMobileNavOpen(state) && getMenuVersion(state) === menuVersion;



// WEBPACK FOOTER //
// ./src/services/header/selector.js